import React from 'react';
import Navbar1 from './Components/Navbar1';
import Middle from './Components/Middle';
import About from './Components/About';
import Aggreator from './Components/Aggreagtor';
import Feature from './Components/Feature';
import Roadmap from './Components/Raodmap';
import Avatar from './Components/Avatar';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App">
      
      <Navbar1></Navbar1>
      <Middle></Middle>
      <About></About>
      <Aggreator></Aggreator>
      <Feature></Feature>
      <Roadmap></Roadmap>
      <Avatar></Avatar>
      <Footer></Footer>

    </div>
  );
}

export default App;
